export default "__VITE_ASSET__BtnhFedl__"